import React from 'react';
import { Select } from '@input';
import { keys, propertyTypes, fieldTypes } from '@enums';

const options = Object.values(propertyTypes);

function PropertyType(props) {
  return (
    <Select
      label="Property Type"
      className="input-property-type"
      fieldClassName="field-property-type"
      name={keys.PROPERTY_TYPE}
      maxWidth={200}
      options={options}
      {...props}
    />
  );
}

function validate(value) {
  if (!value) {
    return 'Please select a property type';
  }

  if (!options.find(o => value === o.value)) {
    return 'Invalid property type';
  }
}

export default { Component: PropertyType, validate, type: fieldTypes.SELECT };
